import styled from 'styled-components';

import { theme } from '../layout/theme';

export const Text = styled.div`
  &.underline {
    text-decoration: underline;
  }

  &.size-xsmall {
    font-size: 0.75rem;
  }

  &.size-small {
    font-size: 0.875rem;
  }

  &.size-standard {
    font-size: 1rem;
  }

  &.size-large {
    font-size: 1.125rem;
  }

  &.size-xlarge {
    font-size: 1.25rem;
  }

  &.weight-thin {
    font-weight: ${theme.font.weight.thin};
  }

  &.weight-regular {
    font-weight: ${theme.font.weight.regular};
  }

  &.weight-medium {
    font-weight: ${theme.font.weight.medium};
  }

  &.weight-bold {
    font-weight: ${theme.font.weight.bold};
  }

  &.align-left {
    text-align: left;
  }

  &.align-center {
    text-align: center;
  }

  &.align-right {
    text-align: right;
  }

  &.tone-main {
    color: ${theme.colors.text.main};
  }

  &.tone-alt {
    color: ${theme.colors.text.alt};
  }

  &.tone-ghost {
    color: ${theme.colors.text.ghost};
  }

  &.tone-error {
    color: ${theme.colors.ui.negative};
  }

  &.tone-success {
    color: ${theme.colors.ui.positive};
  }

  &.tone-highlight {
    color: ${theme.colors.text.highlight};
  }

  &.tone-link {
    color: ${theme.colors.text.link};
  }

  &.tone-warning {
    color: ${theme.colors.text.warning};
  }

  &.white-space-nowrap {
    white-space: nowrap;
  }

  &.white-space-normal {
    white-space: normal;
  }

  &.overflow-ellipsis {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.tone-sale {
    color: ${theme.colors.text.sale};
  }

  ${theme.screens.LtMd} {
    &.size-xsmall-ltmd {
      font-size: 0.75rem;
    }

    &.size-small-ltmd {
      font-size: 0.875rem;
    }

    &.size-standard-ltmd {
      font-size: 1rem;
    }

    &.size-large-ltmd {
      font-size: 1.125rem;
    }

    &.size-xlarge-ltmd {
      font-size: 1.25rem;
    }
  }

  ${theme.screens.Md} {
    &.size-xsmall-md {
      font-size: 0.75rem;
    }

    &.size-small-md {
      font-size: 0.875rem;
    }

    &.size-standard-md {
      font-size: 1rem;
    }

    &.size-large-md {
      font-size: 1.125rem;
    }

    &.size-xlarge-md {
      font-size: 1.25rem;
    }
  }
`;
